import { createApp } from 'vue';
import { createI18n } from 'vue-i18n';

import i18nMessages from 'dashboard/i18n';
import * as Sentry from '@sentry/vue';
import {
  initializeAnalyticsEvents,
  initializeChatwootEvents,
} from 'dashboard/helper/scriptHelpers';
import App from '../v3/App.vue';
import router, { initalizeRouter } from '../v3/views/index';
import store from '../v3/store';
import FluentIcon from 'shared/components/FluentIcon/DashboardIcon.vue';
import { applyCustomBrandColor } from 'shared/helpers/brandColor';
// import { emitter } from '../shared/helpers/mitt';

// [VITE] This was added in https://github.com/chatwoot/chatwoot/commit/b57063a8b83c86819bd285f481298d7cd38ad50e
// Commenting it out for Vite migration
// Vue.config.env = process.env;

applyCustomBrandColor(window?.globalConfig?.BRAND_PRIMARY_COLOR);

// White-label global: troca a marca do produto pela marca que o cliente vê
// (installationName do globalConfig, com override do parceiro). Mesmo mecanismo
// do entrypoint dashboard.js. No-op em conta direta.
const BRAND_LITERALS = /Chatwoot|ChatSuite/g;
const brandPostTranslation = translated => {
  if (typeof translated !== 'string' || !translated.includes('Chat')) {
    return translated;
  }
  let brand;
  try {
    brand = store.getters['globalConfig/get']?.installationName;
  } catch (error) {
    brand = undefined;
  }
  if (!brand) return translated;
  return translated.replace(BRAND_LITERALS, brand);
};

const i18n = createI18n({
  legacy: false, // https://github.com/intlify/vue-i18n/issues/1902
  locale: window.chatwootConfig?.selectedLocale || 'en',
  fallbackLocale: 'en', // chaves faltantes (ex.: es incompleto) caem no inglês, não na key crua
  messages: i18nMessages,
  postTranslation: brandPostTranslation,
});

// Expõe o i18n pra troca de idioma em runtime (o seletor PT/EN/ES do signup usa
// window.i18n.global.locale). Sem isso, trocar idioma não mudava os textos.
// Mesmo padrão dos entrypoints dashboard.js e widget.js.
window.i18n = i18n;

const app = createApp(App);
app.use(i18n);
app.use(store);
app.use(router);

// Vue.use(VueRouter);
// Vue.use(VueI18n);
// Vue.prototype.$emitter = emitter;
app.component('fluent-icon', FluentIcon);

if (window.errorLoggingConfig) {
  Sentry.init({
    app,
    dsn: window.errorLoggingConfig,
    denyUrls: [
      // Chrome extensions
      /^chrome:\/\//i,
      /chrome-extension:/i,
      /extensions\//i,

      // Locally saved copies
      /file:\/\//i,

      // Safari extensions.
      /safari-web-extension:/i,
      /safari-extension:/i,
    ],
    integrations: [Sentry.browserTracingIntegration({ router })],
    ignoreErrors: [
      'ResizeObserver loop completed with undelivered notifications',
    ],
  });
}

initializeChatwootEvents();
initializeAnalyticsEvents();
initalizeRouter();

window.onload = () => {
  app.mount('#app');
};
